import Webcam from "react-webcam";
import React, { useRef, useEffect, useState } from "react";
import { useFaceDetection } from "react-use-face-detection";
import FaceDetection from "@mediapipe/face_detection";
import { Camera } from "@mediapipe/camera_utils";
import { useNavigate } from "react-router-dom";
import { Stack, Button, Card, CardMedia, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { browserName } from "react-device-detect";
import "react-loading-skeleton/dist/skeleton.css";
import { IWebImage } from "../../shared/dtos";
// import {
//   stageDetailsAPICall,
//   startOverAPICall,
//   webImageBase64APICall,
// } from "../../shared/APICalls";
import routesData from "../../shared/routes.json";
import CamStyles from "./WebCam.module.scss";
import icon from "../../Components/assets/Images/iconnew.svg";
import StartOverBackDrop from "../StartOverBackDrop";
import ErrorSnackBar from "../SnackBars/ErrorSnackBar";
import StageLayoutEkyc from "../../Layouts/StageLayoutEkyc";
import {
  EmailMobilelocationCheckAPICall,
  GetStageDetailsAPICall,
  SubmitIPVAPICall,
} from "../../pages/EmailandMobileUpdate/EmailMobileUpdateAPICalls";
import SnackBar from "../SnackBars/SnackBar";
import axios from "axios";
import backicon from "../../Components/assets/Images/back.svg";
import keyboardicon from "../../Components/assets/Images/ipvicongrey.svg";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import { LocationCheckAPICall } from "../../shared/APICalls";

const width = 160;
const height = 160;

const IPV = (): JSX.Element => {
  const { webcamRef, boundingBox, isLoading, detected, facesDetected }: any =
    useFaceDetection({
      faceDetectionOptions: {
        model: "short",
      },
      faceDetection: new FaceDetection.FaceDetection({
        locateFile: (file: any) =>
          `https://cdn.jsdelivr.net/npm/@mediapipe/face_detection/${file}`,
      }),
      camera: ({ mediaSrc, onFrame }: any) =>
        new Camera(mediaSrc, {
          onFrame,
          width,
          height,
        }),
    });

  const [previewUrl, setPreviewUrl] = useState("");
  const [previewBase64, setPreviewBase64] = useState("");

  const [setVisible, setsetVisible] = useState<any>("hidden");

  const [allowCapture, setAllowCapture] = useState(true);
  const [showCamera, setShowCamera] = useState(true);
  const [isSafari, setisSafari] = useState(false);
  const [Border, setBorder] = useState("");
  const [loading, setloading] = useState(false);
  const [isloading, setisloading] = useState(false);
  const [completedStages, setCompletedStages] = useState<any>();
  const [backdrop, setBackDrop] = useState(false);
  const [reload, setReload] = useState(true);
  const [rejectMessage, setRejectMessage] = useState("");
  const [take, settake] = useState(true);
  const [errormessage, seterrormessage] = useState("");
  const [IPAddress, setIPAddress] = useState("");
  const [showContent, setshowContent] = useState(true);
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const navigationData = routesData;

  const requestid: any = sessionStorage.getItem("emrequestid");

  const canvasRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchIPAddress = async () => {
      try {
        const response = await axios.get(
          "https://ipapi.co/json/?key=jmJoC4fsM8a1wzvqBWZsEBfRiXtQqsTtz4XdAXaDb27gq2s9QJ"
        );
        // setIPAddress(response.data);
        setIPAddress(response.data?.ip);
      } catch (err: any) {}
    };
    fetchIPAddress();
  }, []);

  useEffect(() => {
    if (IPAddress !== "") {
      LocationCheckAPICall(IPAddress?.trim())
        .then((response: any) => {
          if (response.data.data) {
            sessionStorage.setItem("latitude", response.data.data.latitude);
            sessionStorage.setItem("longitude", response.data.data.longitude);
          }
        })
        .catch((error: any) => {
          seterrormessage("latitude and longitude not found");
          setTimeout(() => {
            seterrormessage("");
          }, 5000);
        });
    }
  }, [IPAddress]);

  useEffect(() => {
    settake(true);
    setTimeout(() => {
      settake(false);
    }, 1500);

    let obj: any = {
      request_id: requestid ? requestid : "",
      stage: "ipv",
    };

    GetStageDetailsAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;

        // console.log("stageResponse", response.data.data.url);
        if (response.data.data.ErrMessage) {
          setRejectMessage(response.data.data.ErrMessage);
        }

        const retakeImage = sessionStorage.getItem("re-take");

        if (retakeImage === "retake") {
          setPreviewUrl("");
        } else {
          if (response.data.data.img_base64) {
            // console.log(
            //   "responseData.data.data?.img_base64",
            //   responseData.data?.img_base64
            // );
            setPreviewUrl(
              responseData.data?.img_base64
                ? `data:image/png;base64,${responseData.data.img_base64}`
                : ""
            );
            // setPreviewUrl(response.data.data.url);
          }
        }
        if (response.data.data.img_base64) {
          setPreviewBase64(response.data.data.img_base64);
        }

        setReload(false);
      })
      .catch((error: any) => {
        //  console.log("error", error);
      });

    let intervalId: any;
    let alertShown = false;

    const startCameraInterval = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
        });
        stream.getTracks().forEach((track) => track.stop());

        setsetVisible("visible");
        setShowCamera(true);
        clearInterval(intervalId);
      } catch (error: any) {
        if (browserName.includes("Safari")) {
          setisSafari(true);
        }
        setShowCamera(false);
        if (
          !alertShown &&
          (error.name === "NotAllowedError" ||
            error.name === "PermissionDeniedError")
        ) {
          alertShown = true;
          const shouldAskForPermission = window.confirm(
            "Camera access is blocked. Please unblock it in browser settings."
          );
          if (shouldAskForPermission) {
            intervalId = setInterval(async () => {
              try {
                const stream = await navigator.mediaDevices.getUserMedia({
                  video: true,
                });
                stream.getTracks().forEach((track) => track.stop());
                clearInterval(intervalId);
                // console.log("video is true");
                // setShowCamera(true);
                window.location.reload();
              } catch (error: any) {
                // console.error(error);
              }
            }, 1000);
          } else {
            // console.error(error);
          }
        }
      }
    };
    if (browserName !== "Firefox") {
      intervalId = setInterval(startCameraInterval, 1000);
    }
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (facesDetected > 1) {
      setAllowCapture(false);

      setBorder("4px solid red");
    } else if (facesDetected === 1) {
      setAllowCapture(true);

      setBorder("4px solid green");
    } else {
      if (isLoading === false) {
        setAllowCapture(false);

        setBorder("4px solid red");
      }
    }
  }, [facesDetected]);

  const capture = React.useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    //console.log(imageSrc, "imageSrc");
    setPreviewUrl(imageSrc);
  }, [webcamRef]);

  function webImageBase64() {
    setloading(true);
    let obj: any = {
      ipv_base64: previewBase64 === "" ? previewUrl : previewBase64,
      request_id: requestid,
      latitude: sessionStorage.getItem("latitude"),
      longitude: sessionStorage.getItem("latitude"),
    };

    SubmitIPVAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        // console.log("responseDataIPV", responseData);
        setloading(false);
        if (responseData.data.next_stage) {
          // navigate(navigationData[responseData.data.stage]);
          window.location.href = `/emailandmobileupdate/${responseData.data.next_stage}`;
        }
      })
      .catch((error: any) => {
        setloading(false);
        if (error.response.data.message) {
          seterrormessage(error.response.data.message);
          setTimeout(() => {
            seterrormessage("");
          }, 5000);
        }
      });
  }

  const handleClick = () => {
    sessionStorage.setItem("re-take", "");
    webImageBase64();
  };

  const refreshCamera = () => {
    if (webcamRef.current && webcamRef.current.stream) {
      const stream = webcamRef.current.stream;

      // Stop the current stream
      stream.getTracks().forEach((track: any) => track.stop());

      // Start a new stream
      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then((newStream) => {
          webcamRef.current.stream = newStream;
        })
        .catch((error) => {
          //  console.error("Error refreshing camera:", error);
        });
    }
  };

  return (
    <div className={CamStyles.main}>
      <div className={CamStyles.mainWrapper}>
        <ErrorSnackBar message={rejectMessage} />
        <SnackBar message={errormessage} />
        <div className={CamStyles.wrapper}>
          <div className={CamStyles.step}>
            <img src={keyboardicon} /> Step 2 of 3
          </div>
          <div>
            <p className={CamStyles.Header}>Capture Your Photo</p>
          </div>
          <div className={CamStyles.Container}>
            <div style={{ width, height, position: "relative" }}>
              <div>
                {previewUrl === "" ? (
                  <>
                    <Webcam
                      audio={false}
                      ref={webcamRef}
                      forceScreenshotSourceSize
                      screenshotFormat="image/png"
                      style={{
                        height,
                        width,
                        borderRadius: "50%",
                        position: "absolute",
                        border: Border,
                        marginTop: "10px",
                        // display: isLoading === true ? "none" : "block",
                      }}
                    />
                  </>
                ) : (
                  <div>
                    <Card
                      sx={{
                        width: 162,
                        marginTop: "10px",
                        borderRadius: "50%",
                        zIndex: 100,
                        background: "white",
                        marginLeft: "1px",
                      }}
                    >
                      <CardMedia
                        component="img"
                        height="162"
                        image={previewUrl}
                        sx={{
                          zIndex: 100,
                          position: "absolute",
                          borderRadius: "50%",
                          objectFit: "contain",
                        }}
                      />
                    </Card>
                    <Stack width={"150px"} style={{ margin: "10px 0" }}></Stack>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {backdrop && <StartOverBackDrop />}

        <Stack style={{ marginTop: "20px" }}>
          <>
            {showCamera ? (
              <Stack alignItems={"center"}>
                {previewUrl === "" ? (
                  <>
                    <Stack
                      alignItems={"center"}
                      marginTop={"0px"}
                      height={"10px"}
                    >
                      {!allowCapture ? (
                        <Typography style={{ color: "red" }}>
                          No Face/ Detected too many faces
                        </Typography>
                      ) : (
                        ""
                      )}
                    </Stack>
                    <div className={CamStyles.textdiv}>
                      <p className={CamStyles.instructiontext}>
                        <DoneOutlinedIcon style={{ color: "#049981" }} /> Ensure
                        your face is well-lit and centered in the frame. stored.
                      </p>
                      <p className={CamStyles.instructiontext}>
                        <DoneOutlinedIcon style={{ color: "#049981" }} /> Remove
                        any accessories that may obstruct your face.(like
                        sunglasses or hats).
                      </p>
                      <p className={CamStyles.instructiontext}>
                        <DoneOutlinedIcon style={{ color: "#049981" }} /> Click
                        "Capture Photo" when you're ready.
                      </p>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      {!take ? (
                        <Button
                          sx={{
                            marginTop: "20px",
                            height: "50px",
                            width: { xs: "100%", sm: "187px" },
                          }}
                          className={CamStyles.takePhoto}
                          variant="contained"
                          onClick={capture}
                          disabled={!allowCapture}
                        >
                          Capture Photo
                        </Button>
                      ) : (
                        <Button
                          sx={{
                            marginTop: "20px",
                            height: "50px",
                            width: { xs: "100%", sm: "187px" },
                          }}
                          className={CamStyles.takePhoto}
                          variant="contained"
                          onClick={capture}
                          disabled
                        >
                          Capture Photo
                        </Button>
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    <div className={CamStyles.textdiv}>
                      <p className={CamStyles.instructiontext}>
                        <DoneOutlinedIcon style={{ color: "#049981" }} /> Ensure
                        your face is well-lit and centered in the frame. stored.
                      </p>
                      <p className={CamStyles.instructiontext}>
                        <DoneOutlinedIcon style={{ color: "#049981" }} /> Remove
                        any accessories that may obstruct your face.(like
                        sunglasses or hats).
                      </p>
                      <p className={CamStyles.instructiontext}>
                        <DoneOutlinedIcon style={{ color: "#049981" }} /> Click
                        "Capture Photo" when you're ready.
                      </p>
                    </div>
                    <div className={CamStyles.buttonSection}>
                      <Button
                        sx={{
                          color: "#111111",
                          borderColor: "#111111",
                          width: { xs: "100%", sm: "187px" },
                          height: "50px",
                        }}
                        variant="outlined"
                        onClick={() => {
                          setPreviewUrl("");
                          refreshCamera();
                          sessionStorage.setItem("re-take", "retake");
                          // if (reload === true) {
                          window.location.reload();
                          // }
                        }}
                        className={CamStyles.buttonStyles}
                      >
                        Re-Take Photo
                      </Button>
                      <LoadingButton
                        variant="contained"
                        onClick={handleClick}
                        loading={loading}
                        disabled={previewUrl === ""}
                        className={CamStyles.continueButton}
                        sx={{
                          width: { xs: "100%", sm: "187px" },
                          height: "50px",
                        }}
                      >
                        {" "}
                        Continue
                      </LoadingButton>
                    </div>
                  </>
                )}
                {/* <div className={CamStyles.startOverSection}>
                  <img src={icon} className={CamStyles.iconImage} />
                  <p className={CamStyles.paratext}>
                    {" "}
                    if the above mentioned info not yours
                    <span
                      className={CamStyles.startoverbutton}
                      onClick={handleStartOver}
                    >
                      Start Over
                    </span>
                  </p>
                </div> */}
              </Stack>
            ) : (
              <Stack alignItems={"center"} justifyContent={"center"}>
                <Typography>
                  Grant the Camera access to proceed further{" "}
                </Typography>
              </Stack>
            )}
          </>
          {/* )} */}
        </Stack>

        {isSafari ? (
          <Stack alignItems={"center"} justifyContent={"center"}>
            <Typography sx={{ textAlign: "center" }}>
              Please Press Reload Button after granting camera access
            </Typography>
            <Button
              variant="outlined"
              onClick={() => {
                window.location.reload();
              }}
              style={{ color: "#006779" }}
            >
              Reload
            </Button>
          </Stack>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default IPV;
